import * as HLC from '../../infrastructure/clock/hybrid-logical-clock';
import { CloudEvent } from 'cloudevents';
import { v4 as uuidv4 } from 'uuid';
export class BaseEvent {
    static setSource(source) {
        BaseEvent.source = source;
    }
    constructor({ subject, type, payload, metadata, fromPersistence, }) {
        this.metadata = metadata || {};
        this.sortKey =
            fromPersistence?.sortKey || HLC.HybridLogicalClock.getInstance().generateTimestampNow();
        this.event = new CloudEvent({
            id: fromPersistence?.eventId || uuidv4(),
            source: BaseEvent.source,
            subject,
            type,
            data: payload,
            time: new Date(this.sortKey.ts).toISOString(),
            specversion: '1.0',
            datacontenttype: 'application/json',
        });
    }
    getEvent() {
        return this.event;
    }
    getPayload() {
        return this.getEvent().data;
    }
    getMetadata() {
        return this.metadata;
    }
    getSortKey() {
        return this.sortKey;
    }
    getSubject() {
        return this.event.subject || '';
    }
    getSource() {
        return this.event.source;
    }
    getType() {
        return this.event.type;
    }
}
BaseEvent.source = 'NOT_SET';
//# sourceMappingURL=base-event.js.map